<template>
  <div class="bodyitem">
    <div class="bodytitle">
      {{ title }}
    </div>
    <div class="bodyitembody">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  name: "item",
  components: {},
  props: {
    title: {
      type: String,
      default() {
        return '统计数据';
      }
    }
  },
  data() {
    return {
      status: ''
    }
  },
  watch: {},
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.bodyitem {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #77f0ff, #77f0ff) left top no-repeat,linear-gradient(to bottom, #77f0ff, #77f0ff) left top no-repeat,linear-gradient(to left, #77f0ff, #77f0ff) right top no-repeat,linear-gradient(to bottom, #77f0ff, #77f0ff) right top no-repeat,linear-gradient(to left, #77f0ff, #77f0ff) left bottom no-repeat,linear-gradient(to bottom, #77f0ff, #77f0ff) left bottom no-repeat,linear-gradient(to left, #77f0ff, #77f0ff) right bottom no-repeat,linear-gradient(to left, #77f0ff, #77f0ff) right bottom no-repeat rgba(0, 6, 20, 0.7);
  background-size: 2px 18px, 18px 2px, 2px 18px, 18px 2px;
  border: 1px solid #004566;
  box-shadow: inset 0px 0px 20px 0px #004566;

  .bodytitle {
    width: 2rem;
    height: .5rem;
    background: url("../../assets/itemtitlebg1.png");
    background-size: 100% 100%;
    position: absolute;
    left: 50%;
    margin-left: -1rem;
    top: -0.25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;
    font-size: 0.2rem;
    font-family: AlibabaPuHuiTiB;
    font-weight: 400;
    color: #77F0FF;
    flex-direction: row;
  }

  .bodyitembody {
    position: relative;
    width: 96%;
    height: 100%;
    padding: 3%;
    padding-top: 6%;
    margin: auto;
  }

  .icon_top_left {
    position: absolute;
    left: -1px;
    top: -1px;
  }

  .icon_right_top {
    position: absolute;
    right: -1px;
    top: -1px;
  }

  .icon_left_bottom {
    position: absolute;
    left: -1px;
    bottom: -1px;
  }

  .icon_right_bottom {
    position: absolute;
    right: -1px;
    bottom: -1px;
  }
}
</style>
